<template>
  <header class="header">
<!--    <div class="header-top">-->
<!--      <div class="container">-->
<!--        <div class="header-top-content">-->
<!--          <div class="header-actions">-->
<!--            <a -->
<!--              v-if="currentLanguage === 'zh'" -->
<!--              href="#" -->
<!--              class="lang-link" -->
<!--              @click.prevent="toggleLanguage"-->
<!--            >-->
<!--              EN-->
<!--            </a>-->
<!--            <a -->
<!--              v-else -->
<!--              href="#" -->
<!--              class="lang-link" -->
<!--              @click.prevent="toggleLanguage"-->
<!--            >-->
<!--              中文-->
<!--            </a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <nav class="navbar">
      <div class="container">
        <div class="navbar-content">
          <button 
            class="mobile-menu-toggle"
            @click="toggleMobileMenu"
            :aria-expanded="isMobileMenuOpen"
            aria-label="Toggle menu"
          >
            <span class="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
          <div class="logo">
            <a href="#home">
              <img src="@/assets/logo.png" alt="新加坡福清会馆" />
            </a>
          </div>
          <ul 
            class="nav-menu"
            :class="{ 'mobile-menu-open': isMobileMenuOpen }"
          >
          <li class="nav-item">
            <a 
              href="#about" 
              class="nav-link"
              @click.prevent="toggleDropdown($event)"
            >
              关于我们
              <span class="dropdown-arrow">▼</span>
            </a>
                     <ul class="dropdown-menu">
                       <li><a href="#mission" @click="closeMobileMenu">宗旨</a></li>
                       <li><a href="#council" @click="closeMobileMenu">理事会</a></li>
                       <li><a href="#milestones" @click="closeMobileMenu">里程碑</a></li>
                       <li><a href="#venue" @click="closeMobileMenu">场地租用</a></li>
                       <li><a href="#faq" @click="closeMobileMenu">常见问题</a></li>
                     </ul>
          </li>
          <li class="nav-item">
            <a 
              href="#registration" 
              class="nav-link"
              @click.prevent="toggleDropdown($event)"
            >
              附属小学
              <span class="dropdown-arrow">▼</span>
            </a>
            <ul class="dropdown-menu">
              <li><a href="#poiching" @click="closeMobileMenu">培青学校</a></li>
              <li><a href="#faq?tab=p1-registration" @click="closeMobileMenu">小学报名常见问题</a></li>
            </ul>
          </li>
          <li class="nav-item">
            <a href="#historical-materials" class="nav-link" @click="closeMobileMenu">历史长廊</a>
          </li>
          <li class="nav-item">
            <a href="#bookings" class="nav-link" @click="closeMobileMenu">礼堂租赁</a>
          </li>
          <li class="nav-item">
            <a href="#join" class="nav-link" @click="closeMobileMenu">加入我们</a>
          </li>
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      currentLanguage: 'zh', // 'zh' for 中文, 'en' for English
      isMobileMenuOpen: false
    }
  },
  methods: {
    toggleLanguage() {
      this.currentLanguage = this.currentLanguage === 'zh' ? 'en' : 'zh'
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen
    },
    closeMobileMenu() {
      this.isMobileMenuOpen = false
    },
    toggleDropdown(event) {
      // Only toggle on mobile
      if (window.innerWidth <= 768) {
        const navItem = event.currentTarget.closest('.nav-item')
        const dropdown = navItem.querySelector('.dropdown-menu')
        if (dropdown) {
          const isOpen = dropdown.classList.contains('mobile-dropdown-open')
          // Close all dropdowns first
          document.querySelectorAll('.dropdown-menu').forEach(menu => {
            menu.classList.remove('mobile-dropdown-open')
          })
          // Toggle current dropdown
          if (!isOpen) {
            dropdown.classList.add('mobile-dropdown-open')
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.header {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.header-top {
  background: var(--primary-color);
  color: white;
  padding: 0.75rem 0;
}

.header-top-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.header-actions {
  display: flex;
  gap: 0.5rem;
}

.lang-link {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  text-decoration: none;
  transition: all 0.3s ease;
  font-size: 0.875rem;
}

.lang-link:hover {
  background: rgba(255, 255, 255, 0.3);
}

.lang-link.active {
  background: white;
  color: var(--primary-color);
}

.navbar {
  background: white;
  border-bottom: 1px solid var(--border-color);
}

.navbar-content {
  display: flex;
  align-items: center;
  gap: 2rem;
  position: relative;
}

.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  z-index: 1001;
}

.hamburger-icon {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 24px;
  height: 18px;
}

.hamburger-icon span {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--text-primary);
  transition: all 0.3s ease;
  border-radius: 2px;
}

.mobile-menu-toggle[aria-expanded="true"] .hamburger-icon span:nth-child(1) {
  transform: rotate(45deg) translate(6px, 6px);
}

.mobile-menu-toggle[aria-expanded="true"] .hamburger-icon span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-toggle[aria-expanded="true"] .hamburger-icon span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

.logo a {
  display: inline-block;
  text-decoration: none;
}

.logo img {
  height: 50px;
  width: auto;
  object-fit: contain;
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 0;
  flex: 1;
}

.nav-item {
  position: relative;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 1rem 1.5rem;
  color: var(--text-primary);
  text-decoration: none;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
}

.nav-link:hover {
  color: var(--primary-color);
  background: var(--surface);
  border-bottom-color: var(--primary-color);
}

.dropdown-arrow {
  font-size: 0.75rem;
  margin-left: 0.25rem;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  min-width: 200px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  list-style: none;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: all 0.3s ease;
  z-index: 100;
}

.nav-item:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-menu li {
  border-bottom: 1px solid var(--border-color);
}

.dropdown-menu li:last-child {
  border-bottom: none;
}

.dropdown-menu a {
  display: block;
  padding: 0.75rem 1.5rem;
  color: var(--text-primary);
  text-decoration: none;
  transition: all 0.3s ease;
}

.dropdown-menu a:hover {
  background: var(--surface);
  color: var(--primary-color);
  padding-left: 2rem;
}

@media (max-width: 768px) {
  .mobile-menu-toggle {
    display: block;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
  }

  .navbar-content {
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 0;
    position: relative;
  }

  .logo {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .logo img {
    height: 40px;
  }

  .nav-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background: white;
    flex-direction: column;
    width: 100%;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 999;
  }

  .nav-menu.mobile-menu-open {
    max-height: 80vh;
    overflow-y: auto;
  }

  .nav-item {
    border-bottom: 1px solid var(--border-color);
  }

  .nav-item:last-child {
    border-bottom: none;
  }

  .nav-link {
    padding: 1rem 1.25rem;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .dropdown-menu {
    position: static;
    opacity: 0;
    visibility: hidden;
    max-height: 0;
    overflow: hidden;
    transform: none;
    box-shadow: none;
    border-top: none;
    background: var(--surface);
    transition: max-height 0.3s ease, opacity 0.3s ease;
  }

  .dropdown-menu.mobile-dropdown-open {
    opacity: 1;
    visibility: visible;
    max-height: 500px;
    border-top: 1px solid var(--border-color);
  }

  .dropdown-menu a {
    padding: 0.875rem 1.5rem 0.875rem 2.5rem;
    min-height: 44px;
    display: flex;
    align-items: center;
  }
}

@media (max-width: 480px) {
  .nav-link {
    padding: 0.875rem 1rem;
    font-size: 0.95rem;
  }

  .dropdown-menu a {
    padding: 0.875rem 1.25rem;
    font-size: 0.9rem;
  }
}
</style>

